import suppliersNo from '../resources/no/suppliers.json';
import suppliersSe from '../resources/se/suppliers.json';
import { SuppliersLanguageResources } from '../types/SuppliersResources';

export const suppliersI18nResources: SuppliersLanguageResources = {
  no: { suppliers: suppliersNo },
  se: { suppliers: suppliersSe },
};